import { Box, Skeleton } from "@mui/material";
import React from "react";
import { colors } from "../../common/pallette/colors";
import './styles.css';
import TableSkeleton from "../TableSkeleton";

export const GoalCardSkeleton = () => {

    return (
        <Box
        className={'cardContainer'}
        sx={{ 
            border: `2px solid ${colors.grey.light}`
         }}>
            <Box className={'goalCardHeader mb5'}>
                <Skeleton width={'100px'}/>
                <Box className={'goalCardTopRight'}>
                    <Skeleton width={'80px'} className="mr10" />
                    <Skeleton width={'80px'} />
                </Box>
            </Box>
            <Skeleton width={'300px'} />
            <Box sx={{ width: '100%', mt: '10px', mb: '10px', display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton width={'98%'} />
                <Skeleton width={'1%'} />
            </Box>
            <Skeleton width={'100px'} />
            <Box sx={{ display: "flex", mb: 2 }}>
                {
                    [...Array(3)].map(() => {
                        return(
                        <Box sx={{ display: "flex", mr: 4 }}>
                            <Skeleton variant="circular" width={'20px'} height={'20px'} className="mr10" />
                            <Skeleton width={'80px'}/>
                        </Box>)
                    })
                }
            </Box>
            <Skeleton width={'100px'} />
            <Skeleton width={'140px'}/>
            <TableSkeleton rowCount={2} cellCount={3} width={1400} />
        </Box>
    )
}